import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button, useTheme } from 'react-native-paper';
import BaseBottomSheet from './BaseBottomSheet';
import { Job } from '../types/Job';
import { formatAmount as fmt } from '../utils/formatAmount';

interface PickUpJobSheetProps {
  job: Job | null;
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation sheet shown before picking up a job. Shared by the driver board
 * and a driving supervisor's Job Queue.
 */
const PickUpJobSheet: React.FC<PickUpJobSheetProps> = ({
  job,
  visible,
  onClose,
  onConfirm,
}) => {
  const theme = useTheme();
  return (
    <BaseBottomSheet
      visible={visible}
      onClose={onClose}
      title="Pick up job?"
      height={0.45}
    >
      {job && (
        <View style={styles.sheetContent}>
          <Text style={[styles.sheetRoute, { color: theme.colors.onSurface }]}>
            {job.from} → {job.to}
          </Text>
          <Text style={[styles.sheetAmount, { color: theme.colors.primary }]}>
            {fmt(job.intakeAmount)}
          </Text>
          {job.description ? (
            <Text style={[styles.sheetDesc, { color: theme.colors.onSurfaceVariant }]}>
              {job.description}
            </Text>
          ) : null}
          <Button
            testID="confirm-pickup-button"
            mode="contained"
            icon="truck-check"
            onPress={onConfirm}
            style={styles.sheetBtn}
          >
            Confirm Pick Up
          </Button>
          <Button mode="outlined" onPress={onClose}>
            Cancel
          </Button>
        </View>
      )}
    </BaseBottomSheet>
  );
};

const styles = StyleSheet.create({
  sheetContent: {
    padding: 16,
    gap: 10,
  },
  sheetRoute: {
    fontFamily: 'Manrope-SemiBold',
    fontSize: 18,
  },
  sheetAmount: {
    fontFamily: 'Manrope-Bold',
    fontSize: 22,
  },
  sheetDesc: {
    fontFamily: 'Inter-Regular',
    fontSize: 13,
    lineHeight: 18,
  },
  sheetBtn: {
    marginTop: 4,
    borderRadius: 6,
  },
});

export default PickUpJobSheet;
